import { render, staticRenderFns } from "./LessonCreateForm.vue?vue&type=template&id=0ecb5448&"
import script from "./LessonCreateForm.vue?vue&type=script&lang=js&"
export * from "./LessonCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports